import {
  LocalStorageValue,
  UserScopedLocalStorageKey,
  UserScopedValue
} from 'shared/types/localStorage'

import { lsGetItem } from './lsGetItem'
import { lsSetItem } from './lsSetItem'

export const lsSetUserItem = <K extends UserScopedLocalStorageKey>(
  key: K,
  userId: string,
  value: UserScopedValue<K>
) => {
  lsSetItem(key, {
    ...(lsGetItem(key) ?? {}),
    [userId]: value
  } as LocalStorageValue[K])
}
